import { render } from "./StoresDatabase.vue?vue&type=template&id=704e2458&scoped=true"
import script from "./StoresDatabase.vue?vue&type=script&lang=js"
export * from "./StoresDatabase.vue?vue&type=script&lang=js"

import "./StoresDatabase.vue?vue&type=style&index=0&id=704e2458&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704e2458"]])

export default __exports__